export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/ed3e1222f5d7e466f1889a4510f1de5c.svg";